/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { EditButton, List, TextField, ReferenceField } from 'react-admin'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import ListTitle from '../../../../components/ListTitle'
import Datagrid from '../../../../components/Datagrid/Datagrid'
import Filter from '../../../../components/Filter/FilterComponents'

const styles = {
    myHeader: {
        '&&:before': {
            content: '" ⇅ "',
        },
    },
    header: {
        display: 'none',
    },
}
const useStyles = makeStyles(styles)

export default function FormObjectList(props) {
    const classes = useStyles(props)
    const { quickSearch } = props
    return (
        <List
            sort={{ field: 'code', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="Form Objects" />
                <Datagrid {...props}>
                    <TextField
                        label="Code"
                        headerClassName={classes.myHeader}
                        source="code"
                    />
                    <TextField
                        label="Description"
                        headerClassName={classes.myHeader}
                        source="description"
                    />
                    <ReferenceField source="module_id" reference="SS_ModuleTAB">
                        <TextField
                            label="Module"
                            headerClassName={classes.myHeader}
                            source="description"
                        />
                    </ReferenceField>
                    <ReferenceField source="form_id" reference="SS_FormTAB">
                        <TextField
                            label="Form"
                            headerClassName={classes.myHeader}
                            source="description"
                        />
                    </ReferenceField>

                    {quickSearch ? (
                        <EditButton
                            headerClassName={classes.header}
                            basePath="/SS_ObjectTAB"
                        />
                    ) : (
                        <EditButton basePath="/SS_ObjectTAB" />
                    )}
                </Datagrid>
            </>
        </List>
    )
}

FormObjectList.defaultProps = {
    quickSearch: false,
}
FormObjectList.propTypes = {
    quickSearch: PropTypes.bool,
}
